import $http from './index'

export function getnNum() {
  return $http.get('/Advice/GetAllAdviceCount')
}